export default __webpack_public_path__ + "static/media/users-filters.7560860a.png";